import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";
import { MdLogout, MdTv } from "react-icons/md";

export default function Topbar() {
  const navigate = useNavigate();
  const { rol, nombre, local_nombre, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const titulo =
    rol === "superadmin" ? "Admin General" : local_nombre || "Local";

  return (
    <header
      className="bg-navy text-white px-5 flex items-center justify-between border-b border-white/5"
      style={{ height: 56 }}
    >
      <div className="flex items-center gap-2.5">
        <span className="relative inline-flex items-center justify-center w-7 h-7 rounded-md bg-teal/15 text-teal">
          <MdTv size={16} />
        </span>
        <span className="font-display font-semibold tracking-tight text-[15px]">
          TV<span className="text-teal">CORP</span>
        </span>
        <span className="hidden sm:inline ml-2 h-4 w-px bg-white/10" />
        <span className="hidden sm:inline text-xs text-white/45 font-mono uppercase tracking-wider">
          control room
        </span>
      </div>

      <div className="flex items-center gap-2 text-sm absolute left-1/2 -translate-x-1/2">
        <span className="text-white/70 font-medium">{titulo}</span>
      </div>

      <div className="flex items-center gap-5">
        <div className="flex items-center gap-2 text-xs">
          <span className="tally" data-tone="ready" />
          <span className="text-white/60 font-mono uppercase tracking-wide">en línea</span>
        </div>
        <div className="text-xs text-white/60">{nombre}</div>
        <button
          onClick={handleLogout}
          title="Cerrar sesión"
          className="text-white/50 hover:text-white hover:bg-white/5 rounded-md p-1.5 transition"
        >
          <MdLogout size={17} />
        </button>
      </div>
    </header>
  );
}
